import { AnyAction } from 'redux';

import { reducerWrapper } from '../../support/utils';
import { LinkHubCreatorReducerType } from './types/LinkHubCreatorReducerType';
import {
  FETCH_ORIGINAL_WEB_URL_LINK_DATA,
  UPDATE_ORIGINAL_WEB_URL_LINK_DATA_STATUS,
  FETCH_ALL_LINK_COLLECTIONS,
} from '../../actions/LinkHubCreator/LinkHubCreatorActions';

export const INIT_STATE: LinkHubCreatorReducerType = {
  originalWebUrlLinkData: undefined,
  originalWebUrlLinkDataStatus: 0,
  allLinkCollections: undefined,
};

const Handler = (state: LinkHubCreatorReducerType, action: AnyAction): LinkHubCreatorReducerType => {
  switch (action.type) {
    case FETCH_ORIGINAL_WEB_URL_LINK_DATA.response:
      return {
        ...state,
        originalWebUrlLinkData: action.data?.originalWebUrlLinkData,
      };
    case UPDATE_ORIGINAL_WEB_URL_LINK_DATA_STATUS.response:
      return {
        ...state,
        originalWebUrlLinkDataStatus: action.data?.originalWebUrlLinkDataStatus,
      };
    case FETCH_ALL_LINK_COLLECTIONS.response:
      return {
        ...state,
        allLinkCollections: action.data?.allLinkCollections,
      };
    default:
      return state;
  }
};

const TypelessHandler = (state: any, action: any) => {
  return Handler(state, action);
};

const LinkHubCreatorReducer = reducerWrapper(INIT_STATE, TypelessHandler, {
  request: [FETCH_ORIGINAL_WEB_URL_LINK_DATA, UPDATE_ORIGINAL_WEB_URL_LINK_DATA_STATUS, FETCH_ALL_LINK_COLLECTIONS],
  error: [FETCH_ORIGINAL_WEB_URL_LINK_DATA, UPDATE_ORIGINAL_WEB_URL_LINK_DATA_STATUS, FETCH_ALL_LINK_COLLECTIONS],
});

export default LinkHubCreatorReducer;
